import serpApi from '@/app/Serp/api/serpApi';
import type {
  SerpBriefResponse,
  SerpIdRequest
} from '@/app/Serp/types/serpApiTypes';

const getSerpBriefApi = serpApi.injectEndpoints({
  endpoints: build => ({
    getSerpBriefData: build.query<SerpBriefResponse, SerpIdRequest>({
      query: body => ({
        url: `/serp/v2/brief_content_by_id`,
        method: 'POST',
        body
      }),
      providesTags: ['SerpOverview']
    })
  })
});

export const { useGetSerpBriefDataQuery } = getSerpBriefApi;

export default getSerpBriefApi;
